import { syncURLParams } from "./searchHelpers";
import { ECOVENTURE_CATEGORIES } from "./constants";
import currencyRanges from "./currencyRanges.json";

export const applyFilterURL = (state) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (state.filters.budgets) {
    const currentBudgets = state.filters.budgets.split(",");
    const rangeInSelectedCurrency =
      currencyRanges[state.currency.code].ecoventure.filterRange;

    const results = [];
    currentBudgets.forEach((_b) => {
      results.push(rangeInSelectedCurrency[_b][0]);
    });

    searchParams.set("budgets", results.join(","));
  } else {
    searchParams.delete("budgets");
  }

  if (state.filters.categories) {
    searchParams.set("categories", state.filters.categories);
  } else {
    searchParams.delete("categories");
  }

  if (state.filters.destinations) {
    searchParams.set("destinations", state.filters.destinations);
  } else {
    searchParams.delete("destinations");
  }

  if (state.filters.tripLengths) {
    searchParams.set("tripLengths", state.filters.tripLengths);
  } else {
    searchParams.delete("tripLengths");
  }

  if (state.filters.facilities) {
    searchParams.set("facilities", state.filters.facilities);
  } else {
    searchParams.delete("facilities");
  }

  if (state.filters.experiences) {
    searchParams.set("experiences", state.filters.experiences);
  } else {
    searchParams.delete("experiences");
  }

  syncURLParams(searchParams);
};

export const getPrimaryDestinationFilters = (filters) => {
  return filters.destinations
    .split(",")
    .filter((d) => d)
    .map((dest) => `__odyssey_country_programme.code:${dest}`);
};

export const getBudgetFilters = (filters) => {
  const filteringBudgets = filters.budgets.split(",").filter((x) => x);

  if (filteringBudgets.length === 0) {
    return "__odyssey_price_per_week > 0";
  }

  const selectedCurrency = window.topNavStore.state.currency;
  const rangeInSelectedCurrency =
    currencyRanges[selectedCurrency.code].ecoventure.filterRange;
  const rate = window.zubluCurrencyTable[selectedCurrency.code];

  let numericFilters = [];

  if (filteringBudgets.includes("0")) {
    numericFilters.push(
      `__odyssey_price_per_week:${rangeInSelectedCurrency[0][0] *
        rate} TO ${rangeInSelectedCurrency[0][1] * rate}`
    );
  }
  if (filteringBudgets.includes("500")) {
    numericFilters.push(
      `__odyssey_price_per_week:${rangeInSelectedCurrency[500][0] *
        rate} TO ${rangeInSelectedCurrency[500][1] * rate}`
    );
  }
  if (filteringBudgets.includes("1000")) {
    numericFilters.push(
      `__odyssey_price_per_week:${rangeInSelectedCurrency[1000][0] *
        rate} TO ${rangeInSelectedCurrency[1000][1] * rate}`
    );
  }
  if (filteringBudgets.includes("1500")) {
    numericFilters.push(
      `__odyssey_price_per_week > ${rangeInSelectedCurrency[1500][0] * rate}`
    );
  }

  return [numericFilters];
};

export const getProgrammeLength = (programme) => {
  if (programme.__odyssey_category === ECOVENTURE_CATEGORIES.ECOVENTURE) {
    const lengthMax = programme.__odyssey_max_length;
    const lengthMin = programme.__odyssey_min_length;

    if (lengthMax === lengthMin && lengthMin !== null) {
      return `${lengthMin} weeks`;
    } else if (lengthMin < lengthMax) {
      return `${lengthMin} - ${lengthMax} weeks`;
    } else if (Number.isInteger(lengthMin) && lengthMax === null) {
      return `${lengthMin}+ weeks`;
    }
  } else if (
    programme.__odyssey_category === ECOVENTURE_CATEGORIES.EXPEDITION
  ) {
    const length = programme.__odyssey_expedition_length;

    return `${length} days`;
  }

  return "";
};
